<div class="hold-wrapper"
     (mousedown)="onPressDown($event)"
     (mouseup)="onPressUp($event)"
     (mouseleave)="onPressUp($event)"
     (touchstart)="onPressDown($event)"
     (touchcancel)="onPressUp($event)"
     (touchend)="onPressUp($event)">
    <ng-content></ng-content>
</div>
